/* eslint-disable react/no-array-index-key */
import React from 'react';
import ContentLoader from 'react-content-loader';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const fakeCommands = Array(8).fill(0);
/**
 * Shimmer loader du tableau de commande pour la partie colis prêt
 */
const CommandTableLoader = () => (
  <TableBody>
    {fakeCommands.map((command, index) => (
      <TableRow key={index}>
        <TableCell padding="checkbox">
          <div style={{ width: 24, height: 24, marginLeft: 12 }}>
            <ContentLoader
              height={50}
              width={50}
              speed={2}
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb"
            >
              <rect x="109" y="101" rx="0" ry="0" width="0" height="0" />
              <rect x="80" y="58" rx="0" ry="0" width="0" height="0" />
              <rect x="80" y="58" rx="0" ry="0" width="0" height="0" />
              <rect x="0" y="-1" rx="0" ry="0" width="103" height="60" />
              <rect x="36" y="35" rx="0" ry="0" width="0" height="0" />
            </ContentLoader>
          </div>
        </TableCell>
        <TableCell align="left">
          <ContentLoader
            height={5}
            width={170}
            speed={2}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="24" y="-8" rx="0" ry="0" width="135" height="29" />
          </ContentLoader>
        </TableCell>
        <TableCell align="left">
          <ContentLoader
            height={5}
            width={170}
            speed={2}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="24" y="-8" rx="0" ry="0" width="135" height="29" />
          </ContentLoader>
        </TableCell>
        <TableCell align="left">
          <ContentLoader
            height={5}
            width={170}
            speed={2}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="24" y="-8" rx="0" ry="0" width="135" height="29" />
          </ContentLoader>
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
);

export default CommandTableLoader;
